/**
 * The body of a person create/update, from the drawer's form state.
 *
 * The form keeps an empty jersey number as '' (a controlled input cannot hold
 * null), and that string went to the API as typed. `Person.jersey_number` is
 * a nullable integer, so DRF answered 400 "A valid integer is required." and
 * a person WITHOUT a number could not be saved at all: renaming "Coach Xavi"
 * failed on a field nobody had touched (prod, 21-09-2026).
 *
 * Empty means "no number", which the API spells null. `team_id` is not a
 * person field; the caller turns it into a team membership.
 */
export function personPayload(formData) {
  const { team_id: _teamId, ...person } = formData;
  const raw = person.jersey_number;
  // Number('') and Number(' ') are 0, which is a real shirt number.
  const blank = raw === null || raw === undefined || String(raw).trim() === '';
  const number = blank ? NaN : Number(raw);
  return { ...person, jersey_number: Number.isInteger(number) ? number : null };
}
